export default (that) => [
  {
    field: 'seq',
    width: 28,
    align: 'center',
    fixed: 'left',
    type: 'seq',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_displayScm') || '执行工厂',
    field: 'displayScm',
    align: 'left',
    minWidth: 230,
    showHeaderOverflow: true,
    editRender: { enable: true },
    slots: { default: 'displayScm', edit: 'editScm' },
  },
  {
    title: that.$l('table_label_displayFactory') || '工厂信息',
    field: 'displayFactory',
    align: 'left',
    minWidth: 270,
    showHeaderOverflow: true,
    editRender: { enable: true },
    slots: { default: 'displayFactory', edit: 'editFactory' },
  },
  {
    title: that.$l('table_label_displayOrder') || '订单信息',
    field: 'displayOrder',
    minWidth: 185,
    showHeaderOverflow: true,
    slots: { default: 'displayOrder' },
  },
  {
    title: that.$l('table_label_replyPropose') || '返答建议',
    field: 'replyPropose',
    minWidth: 110,
    showHeaderOverflow: true,
    slots: { default: 'displayReplyPropose' },
  },
  {
    title: that.$l('table_label_replyQty') || '返答数量',
    field: 'replyQty',
    minWidth: 120,
    showHeaderOverflow: true,
    editRender: { enable: true },
    slots: { default: 'displayReplyQty', edit: 'replyQty' },
  },
  {
    title: that.$l('table_label_ctnQty') || '返答箱数',
    field: 'displayCtnQty',
    minWidth: 110,
    showHeaderOverflow: true,
    slots: { default: 'displayCtnQty' },
  },
]
